import { gracenoteApiCall } from '../../api/api';
import { GET_MUNDIAL_BRACKETS } from '../types/matches.types';

const buildChampiosBracket = data => {
  const newArr = [];
  newArr.push({
    ...data.brackets[0].rounds[0],
    pairs: data.brackets[0].rounds[0].pairs.slice(0, 8),
  });
  newArr.push({
    ...data.brackets[0].rounds[1],
    pairs: data.brackets[0].rounds[1].pairs.slice(0, 4),
  });
  newArr.push({
    ...data.brackets[0].rounds[2],
    pairs: data.brackets[0].rounds[2].pairs.slice(0, 2),
  });
  newArr.push({
    ...data.brackets[0].rounds[3],
    pairs: data.brackets[0].rounds[3].pairs.slice(0, 1),
  });

  return newArr;
};

export const getMundialBrackets = () => async dispatch => {
  try {
    const { data } = await gracenoteApiCall({
      url: '/leagues/GNA5MGHG2ZVX2RD/brackets',
    });

    dispatch({
      type: GET_MUNDIAL_BRACKETS,
      payload:
        data.league.id === 'GNA5MGHG2ZVX2RD'
          ? data.brackets[0].rounds
          : buildChampiosBracket(data),
    });
  } catch (error) {}
};
